import { render, staticRenderFns } from "./ModalCapitalAccionista.vue?vue&type=template&id=7346de50"
import script from "./ModalCapitalAccionista.vue?vue&type=script&lang=js"
export * from "./ModalCapitalAccionista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7346de50')) {
      api.createRecord('7346de50', component.options)
    } else {
      api.reload('7346de50', component.options)
    }
    module.hot.accept("./ModalCapitalAccionista.vue?vue&type=template&id=7346de50", function () {
      api.rerender('7346de50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/infoBase/modales/ModalCapitalAccionista.vue"
export default component.exports